module.exports = __webpack_public_path__ + "2c000a67639ccf1f0e9e9681aa350441.svg";